import { createBrowserHistory } from 'history';

const initialState = window['__INITIAL_STATE__'];
const rootPath = initialState && initialState.rootPath;
export default createBrowserHistory({ basename: rootPath || '' });
